import tokens from '@lansforsakringar/core-tokens'
import { css } from 'lit'

import { vars } from '#utils/styles'

export default css`
	:host {
		display: flex;
		flex-direction: column;
	}

	[role='radiogroup'] {
		display: flex;
		flex-direction: column;
		gap: ${vars(tokens.spacing_xs)};
	}

	.label {
		font-size: ${vars(tokens.text_size_label_default)};
		font-weight: ${vars(tokens.font_weight_semibold)};
		line-height: ${vars(tokens.line_height_label_default)};
	}

	.help {
		cursor: default;
		font-size: ${vars(tokens.text_size_caption_default)};
		line-height: ${vars(tokens.line_height_caption_default)};
		color: ${vars(tokens.color_text_secondary)};
	}

	.radios {
		display: flex;
		flex-direction: column;
		gap: ${vars(tokens.spacing_xs)};
	}

	@media (min-width: 600px) {
		.radios {
			align-items: flex-start;
		}
	}

	.validation {
		display: flex;
		align-items: flex-start;
		cursor: default;
		gap: ${vars(tokens.spacing_xs)};
		color: ${vars(tokens.color_text_error)};
		line-height: calc(18 / 14);
		font-size: 0.875rem;

		.icon {
			margin: -0.2rem 0 0 -0.15rem;
		}
	}
`
